import React from 'react';
import styles from './TextGold.module.css';

/**
 * TextGold – Renders text with shaded gold gradient fill.
 * Font size is dynamic only: pass via `size` prop (CSS value) or `className`.
 */
const TextGold = ({
  as: Tag = 'span',
  size,
  className = '',
  style = {},
  children,
  ...rest
}) => {
  const combinedStyle = size ? { ...style, fontSize: size } : style;
  return (
    <Tag
      className={`${styles.gold} ${className}`.trim()}
      style={combinedStyle}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default TextGold;
